export const ACTIVITY_TYPES = {
  MODULE_COMPLETED: 'module_completed',
  PATH_COMPLETED: 'path_completed',
  PATH_ENROLLED: 'path_enrolled',
  WRITEUP_PUBLISHED: 'writeup_published',
  ROOM_LIKED: 'room_liked',
  BADGE_EARNED: 'badge_earned',
  LEAGUE_WON: 'league_won',
} as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[keyof typeof ACTIVITY_TYPES];

export interface ActivityData {
  activityType: ActivityType;
  code: string; // Module/path/room code or writeup slug
  title: string;
  likesCount?: number; // Track like count for activity notifications
}

export interface FollowData {
  followerId: string;
  followerUsername: string;
  followerAvatar?: string;
}

export interface NotificationDocument {
  _id: string;
  userId: string;
  groupId: string;
  description: string;
  icon: 'default' | 'congrats' | string;
  created: Date;
  read?: boolean;
  dateRead: Date;
  isSpecial?: boolean;
  activityData?: ActivityData;
  followData?: FollowData;
  username?: string;
  avatar?: string;
  showOnlyOnce: boolean;
}

export interface NotificationReaction {
  _id?: string;
  notificationId: string;
  userId: string;
  type: 'like' | 'read';
  created: Date;
}
